import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "utils/baseQueryWithReauth";
import { LocationResponse } from "../types/types";

// Create base query with automatic token refresh
const baseLocationQuery = createBaseQueryWithReauth({
  baseUrl: process.env.REACT_APP_UAT_LOCATION_API_URL || '',
});

export const locationApiSlice = createApi({
  reducerPath: 'locationApi',
  baseQuery: baseLocationQuery,
  endpoints: (builder) => ({
    searchLocation: builder.query<LocationResponse, { locationName: string }>({
      query: (data) => ({
        url: `/Search/LocationName/${encodeURIComponent(data.locationName)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useSearchLocationQuery, useLazySearchLocationQuery } = locationApiSlice;

